import { AlertCircle } from "lucide-react";
import { Card } from "src/components/ui/card";

interface ErrorStateProps {
  error?: Error;
}

const ErrorState = ({ error }: ErrorStateProps) => {
  return (
    <div className="mt-56 flex h-full w-full items-center justify-center">
      <Card className="flex h-fit w-fit flex-col items-center justify-center p-10 text-center dark:border-light-gray dark:bg-medium-black">
        <div className="mb-4 fill-black text-black dark:fill-white dark:text-white">
          <AlertCircle className="h-12 w-12" />
        </div>
        <h2 className="mb-3 text-xl font-semibold">
          Oops! Something went wrong
        </h2>
        <p className="mb-4 text-muted-foreground">
          We've been notified and are working to fix the issue.
        </p>
        {error && (
          <p className="mb-4 text-sm text-muted-foreground">
            {error.message}
          </p>
        )}
        <p className="text-muted-foreground">Please try again later.</p>
      </Card>
    </div>
  );
};

export default ErrorState;
